import './SearchBar.css';

export const SearchBar = (props) => {
  const { cdn, onSearch } = props;

  const handleChange = (e) => {
    onSearch(e.target.value);
  };

  return (
    <div className="search-bar">
      <input
        className="search-bar__input"
        type="text"
        placeholder="Rechercher une salle..."
        onChange={handleChange}
      />
      <div className="search-bar__icn">
        <img className="search-bar__icn__img" alt="Search icon" src={`${cdn}pictos/search.svg`} />
      </div>
    </div>
  );
};
